import ReducerUtilities from '../../../shared/store/reducer-utilities';
import optionsCommitTypes from './commit-types';

const INITIAL_OPTIONS_STATE = {
  isLoading: [],
  ftos: null,
  oits: null,
  myOits: null,
  roles: null,
  taskGroups: null,
  trainingPrograms: null,
};

function commonReducers(state = INITIAL_OPTIONS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case optionsCommitTypes.RESET_OPTIONS_STATE:
      return { ...INITIAL_OPTIONS_STATE };
    case optionsCommitTypes.SET_OPTIONS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    case optionsCommitTypes.SET_OPTIONS_KEY:
      return {
        ...state,
        [action.key]: action.options,
      };
    default:
      return state;
  }
}

export default commonReducers;
